// extracted by mini-css-extract-plugin
export default {"loading":"Loading_loading__khbXV","animation":"Loading_animation__NCbXP","animate_out":"Loading_animate_out__aJ7qA","content":"Loading_content__RpiJb","title":"Loading_title__LZ9jc"};